export default __webpack_public_path__ + "static/scam-alert-email-d57b03b362b48070161420de1b449ead.png";